module.exports = __webpack_public_path__ + "img/twitter.c6e5315d.svg";